import React from 'react';
import { Page, Text, View, Image } from '@react-pdf/renderer';

import hgsdLogo from '../../black-textHGSDlogo400px.png';
import ftBendLogo from '../../fbsd_logo_clr_rgb.png';

const MONTHS = [
  '',
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

function getNextMonth(month) {
  console.log(`month: ${month}`);
  return MONTHS[parseInt(month, 10)];
}

function getResult(result) {
  switch (result) {
    case 'Continued (unpaid)':
      return 'Application Fee was not received prior to the hearing.';
    default:
      return result;
  }
}

export default function AppendixD({ styles, data, year, month, footer }) {
  return (
    <Page size='A4'>
      <View style={styles.pageTitle}>
        <Text style={styles.pageTitle}></Text>
      </View>
      <View style={styles.document}>
        <View style={[styles.row, styles.borderBottom]}>
          <Image
            src={window.config.client === 'FT-BEND' ? ftBendLogo : hgsdLogo}
            style={styles.logo}
          />
          <Text style={styles.logoLabel}>Appendix D</Text>
        </View>
        <View style={[styles.row, styles.borderBottom]}>
          <Text style={styles.logo} />
          <Text style={styles.logoLabel}>Continued Applicants</Text>
        </View>
        <View style={styles.section}>
          <Text>
            {`The following applicants have been continued to the hearing in ${getNextMonth(
              parseInt(month, 10) + 1
            )}.`}
          </Text>
        </View>
        <View style={styles.section}>
          <View style={[styles.row, styles.borderBottom]}>
            <Text style={styles.column}>APPLICANT</Text>
            <Text style={styles.column}>PERMIT</Text>
            <Text style={styles.column}>REASON</Text>
            <Text style={styles.column}>RECOMMENDATION</Text>
          </View>
          {data.length === 0 ? (
            <View style={styles.column}>
              <Text>NONE</Text>
            </View>
          ) : null}
          {data.map((permit, i) => (
            <View style={styles.row} key={i}>
              <Text style={styles.column}>{permit.PERMITTEE}</Text>
              <Text style={styles.column}>{permit.CASE_NUMBER}</Text>
              <Text style={styles.column}>{getResult(permit.RESULT)}</Text>
              <Text style={styles.column}>{permit.RECOMMENDATION}</Text>
            </View>
          ))}
        </View>
      </View>
      <View fixed style={styles.footer}>
        {/* <Text style={styles.data}>{footer}</Text> */}
        <Text
          style={styles.data}
          render={({ pageNumber, totalPages }) =>
            `${footer} (${pageNumber}/${totalPages})`
          }
        />
      </View>
    </Page>
  );
}
